module.exports = __webpack_public_path__ + "static/media/Connect-to-a-wallet.525e8eba.svg";